module.exports = __webpack_public_path__ + "img/action_other.bd12098a.png";